import React from "react";
import { Contact } from "@model/contacts/Contact";
import { FormField, FormFieldDirection, FormFieldNote, FormFieldNoteType } from "@ui/common/form/FormField";
import { ImageUrls } from "@ui/common/images/ImageUrls"
import { IconButton } from "@material-ui/core";
import { PencilIcon } from "@ui/common/images/InlinedSvgs"

export function NewEmptyContact(): Contact {
    return {
        id: 0, 
        displayName: "Unassigned", 
        email: "", 
        title: "", 
        deleted: false,
        firstName: null,
        lastName: null,
        companyName: null,
        company: {
            id: 0,
            name: null
        },
        address: null,
        city: null,
        state: null,
        postalCode: null,
        officePhone: null,
        homePhone: null,
        cellPhone: null,
        notes: null,
        isMechanic: false,
        hasActiveWorkOrders: false
    }
}


export function MechanicCard({label,mechanic, isEditable, onEdit, outlineInvalid}: {label: String, mechanic: Contact | null, isEditable?: boolean, onEdit?: () => void, outlineInvalid?: boolean}): JSX.Element {
    return (
        <FormField label={label} direction={FormFieldDirection.Row}>
            <MechanicCardItem mechanic={mechanic ?? NewEmptyContact()} isEditable={isEditable} onEdit={onEdit} outlineInvalid={outlineInvalid} />
        </FormField>
    )
}

// outlineInvalid gets its own class rather than reusing .outlineInvalid: that rule targets a child
// input, and this card renders plain text, so there is no input for the red border to land on.
export function MechanicCardItem({mechanic, isEditable, onEdit, outlineInvalid}: {mechanic: Contact, isEditable?: boolean, onEdit?: () => void, outlineInvalid?: boolean}): JSX.Element {
    return (
        <>
            <div
                className={outlineInvalid ? "mechanic-card-item outline-invalid" : "mechanic-card-item"}
                style={{ minHeight: "43px", marginLeft: "10px"}}
            >
                <div style={{fontWeight: "bold", fontSize: "14px"}}>{mechanic.displayName}</div>
                <FormFieldNote type={FormFieldNoteType.Info}>
                    {mechanic.email}
                </FormFieldNote>
                <FormFieldNote type={FormFieldNoteType.Info}>
                    {mechanic.title}
                </FormFieldNote>
            </div>
            { isEditable ? <IconButton style={{marginLeft: "auto"}} onClick={onEdit} tabIndex={-1}><PencilIcon /></IconButton> : <> </>}
        </>
    )
}
